  /* ============================================================
   SOLARJOEJOE YOUTUBE WIDGET - JavaScript (multi-mode)
   Upload to Shopify Assets folder as: youtube-widget.js

   Supports two display modes via data attributes on the grid:
     data-mode="latest"      -> N most recent long-form videos
     data-mode="top-viewed"  -> N highest-viewed videos published since data-since

   >>> PASTE YOUR API KEY ON THE LINE BELOW <<<
   ============================================================ */

(function() {
  var API_KEY = "AIzaSyCfLy-7DSTSl-vhJRA_z4HmGwfRtLvwnl4";

  var CHANNEL_ID = "UCpcZjDzrHF2X4AH22xbn-Iw";
  var CHANNEL_URL = "https://www.youtube.com/@solarjoejoe";

  // Cache the uploads playlist ID + video pool across multiple widgets on one page
  var cache = { uploadsId: null, allVideos: null, fetching: null };

  function abbreviate(n) {
    n = parseInt(n, 10) || 0;
    if (n < 1000) return n.toString();
    if (n < 10000) return (n / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    if (n < 1000000) return Math.round(n / 1000) + "K";
    if (n < 10000000) return (n / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    return Math.round(n / 1000000) + "M";
  }

  function formatDate(dateStr) {
    try {
      var d = new Date(dateStr);
      return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    } catch(e) { return ""; }
  }

  function parseDurationStr(iso) {
    var m = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!m) return "";
    var h = parseInt(m[1] || 0, 10);
    var mi = parseInt(m[2] || 0, 10);
    var s = parseInt(m[3] || 0, 10);
    var pad = function(x) { return x < 10 ? "0" + x : "" + x; };
    if (h > 0) return h + ":" + pad(mi) + ":" + pad(s);
    return mi + ":" + pad(s);
  }

  function durationSeconds(iso) {
    var m = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!m) return 0;
    return (parseInt(m[1] || 0, 10) * 3600) +
           (parseInt(m[2] || 0, 10) * 60) +
           parseInt(m[3] || 0, 10);
  }

  function escapeHtml(s) {
    var div = document.createElement("div");
    div.textContent = s;
    return div.innerHTML;
  }

  function renderVideos(grid, items) {
    grid.innerHTML = "";
    items.forEach(function(item) {
      var vid = item.id;
      var sn = item.snippet || {};
      var cd = item.contentDetails || {};
      var st = item.statistics || {};
      var thumb = (sn.thumbnails && (sn.thumbnails.high || sn.thumbnails.medium || sn.thumbnails.default) || {}).url
        || "https://i.ytimg.com/vi/" + vid + "/hqdefault.jpg";

      var card = document.createElement("div");
      card.className = "sjj-yt-card";
      card.innerHTML =
        '<div class="sjj-yt-thumb" data-vid="' + vid + '">' +
          '<img src="' + thumb + '" alt="' + escapeHtml(sn.title || "") + '" loading="lazy">' +
          '<div class="sjj-yt-play"></div>' +
          '<span class="sjj-yt-duration">' + parseDurationStr(cd.duration || "") + '</span>' +
        '</div>' +
        '<div class="sjj-yt-meta">' +
          '<p class="sjj-yt-title">' + escapeHtml(sn.title || "") + '</p>' +
          '<p class="sjj-yt-date">' + formatDate(sn.publishedAt) + '</p>' +
          '<div class="sjj-yt-stats">' +
            '<span class="sjj-yt-stat" title="Views">' +
              '<svg viewBox="0 0 24 24"><path d="M12 4.5C7 4.5 2.7 7.6 1 12c1.7 4.4 6 7.5 11 7.5s9.3-3.1 11-7.5c-1.7-4.4-6-7.5-11-7.5zM12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/></svg>' +
              abbreviate(st.viewCount) +
            '</span>' +
            '<span class="sjj-yt-stat" title="Likes">' +
              '<svg viewBox="0 0 24 24"><path d="M2 21h4V9H2v12zm20-11c0-1.1-.9-2-2-2h-6.3l1-4.6V3a1.5 1.5 0 0 0-3-.2L8 8H8v12h11.5a2 2 0 0 0 1.9-1.5l2.5-7c.1-.2.1-.4.1-.5V10z"/></svg>' +
              abbreviate(st.likeCount) +
            '</span>' +
            '<span class="sjj-yt-stat" title="Comments">' +
              '<svg viewBox="0 0 24 24"><path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"/></svg>' +
              abbreviate(st.commentCount) +
            '</span>' +
          '</div>' +
        '</div>';
      grid.appendChild(card);
    });

    grid.addEventListener("click", function(e) {
      var thumb = e.target.closest(".sjj-yt-thumb");
      if (!thumb || thumb.querySelector("iframe")) return;
      var vid = thumb.getAttribute("data-vid");
      thumb.innerHTML =
        '<iframe src="https://www.youtube.com/embed/' + vid + '?autoplay=1&rel=0" ' +
        'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
        'allowfullscreen></iframe>';
    });
  }

  function showError(grid) {
    grid.innerHTML =
      '<div class="sjj-yt-error">' +
        'Unable to load videos right now. ' +
        '<a href="' + CHANNEL_URL + '" target="_blank" rel="noopener">Visit the channel on YouTube</a>' +
      '</div>';
  }

  // Fetch ALL videos from the channel (paginated, cached)
  function fetchAllVideos() {
    if (cache.allVideos) return Promise.resolve(cache.allVideos);
    if (cache.fetching) return cache.fetching;

    cache.fetching = fetch("https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=" + CHANNEL_ID + "&key=" + API_KEY)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.items || !data.items.length) throw new Error("no channel");
        cache.uploadsId = data.items[0].contentDetails.relatedPlaylists.uploads;
        return fetchPlaylistPages(cache.uploadsId);
      })
      .then(function(videoIds) {
        var batches = [];
        for (var i = 0; i < videoIds.length; i += 50) {
          batches.push(videoIds.slice(i, i + 50));
        }
        return Promise.all(batches.map(function(batch) {
          return fetch("https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails,statistics&id=" +
            batch.join(",") + "&key=" + API_KEY)
            .then(function(r) { return r.json(); })
            .then(function(d) { return d.items || []; });
        }));
      })
      .then(function(batchResults) {
        var all = [];
        batchResults.forEach(function(items) { all = all.concat(items); });
        cache.allVideos = all;
        return all;
      });

    return cache.fetching;
  }

  function fetchPlaylistPages(playlistId) {
    var allIds = [];
    var MAX_VIDEOS_TO_FETCH = 200;

    function getPage(pageToken) {
      var url = "https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails&playlistId=" +
        playlistId + "&maxResults=50&key=" + API_KEY +
        (pageToken ? "&pageToken=" + pageToken : "");
      return fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.items) {
            data.items.forEach(function(i) { allIds.push(i.contentDetails.videoId); });
          }
          if (data.nextPageToken && allIds.length < MAX_VIDEOS_TO_FETCH) {
            return getPage(data.nextPageToken);
          }
          return allIds;
        });
    }
    return getPage(null);
  }

  function initWidget(grid) {
    var mode = grid.getAttribute("data-mode") || "latest";
    var count = parseInt(grid.getAttribute("data-count") || "4", 10);
    var since = grid.getAttribute("data-since") || null;
    var excludeShorts = grid.getAttribute("data-exclude-shorts") !== "false";

    fetchAllVideos()
      .then(function(videos) {
        var filtered = videos.slice();

        if (excludeShorts) {
          filtered = filtered.filter(function(v) {
            var secs = durationSeconds(v.contentDetails.duration || "");
            return secs === 0 || secs > 60;
          });
        }

        if (since) {
          var sinceDate = new Date(since);
          filtered = filtered.filter(function(v) {
            return new Date(v.snippet.publishedAt) >= sinceDate;
          });
        }

        if (mode === "top-viewed") {
          filtered.sort(function(a, b) {
            return parseInt(b.statistics.viewCount || 0, 10) - parseInt(a.statistics.viewCount || 0, 10);
          });
        } else {
          filtered.sort(function(a, b) {
            return new Date(b.snippet.publishedAt) - new Date(a.snippet.publishedAt);
          });
        }

        var top = filtered.slice(0, count);
        if (!top.length) { showError(grid); return; }
        renderVideos(grid, top);
      })
      .catch(function(err) {
        console.error("YT widget error:", err);
        showError(grid);
      });
  }

  function run() {
    var grids = document.querySelectorAll(".sjj-yt-grid");
    for (var i = 0; i < grids.length; i++) {
      initWidget(grids[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();